import './video-controls.scss';
class VideoControls {
    constructor (element, index) {
        this.$element = element;
        this.$videoToggleButton = this.$element.querySelector('[data-video-controls="toggle"]');
        this.$videoSoundButton = this.$element.querySelector('[data-video-controls="sound"]');
        this.$video = this.$element.parentNode.querySelector('video');
        this.$videoSeekbar = this.$element.querySelector('[data-video="seekbar"]');
        this.$videoSeekbarBar = this.$element.querySelector('[data-video="bar"]');
        this.$videoSeekbarDuration = this.$element.querySelector('[data-video="duration"]');
        this.$videoSeekbarCurrentTime = this.$element.querySelector('[data-video="currentTime"]');
        this.$$videoTriggers = document.querySelectorAll('[data-stagevideo-play]');
        this.$$modalExits = document.querySelectorAll('.modal__exit');

        this.instanceIndex = index;
    }

    initialize () {
        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        if (reducedMotion) {
            this.$video.pause();
        }

        this.setEvents(this.$video);
    }

    setEvents (video) {
        if (this.$$videoTriggers[this.instanceIndex]) {
            this.$$videoTriggers[this.instanceIndex].addEventListener('click', () => {
                video.play();
                video.setAttribute('playing', true);
            });
        }

        this.$$modalExits.forEach($modalExit => {
            $modalExit.addEventListener('click', () => {
                video.pause();
                video.removeAttribute('playing', true);
            });
        });

        if (this.$videoToggleButton) {
            this.$videoToggleButton.addEventListener('click', () => {
                if (this.$videoToggleButton.classList.contains('is--paused')) {
                    this.$video.play();
                    this.$videoToggleButton.classList.remove('is--paused');
                } else {
                    this.$video.pause();
                    this.$videoToggleButton.classList.add('is--paused');
                }
            });
        }

        if (this.$videoSoundButton) {
            this.$videoSoundButton.addEventListener('click', () => {
                if (this.$videoSoundButton.classList.contains('is--muted')) {
                    this.$video.muted = false;
                    this.$videoSoundButton.classList.remove('is--muted');
                } else {
                    this.$video.muted = true;
                    this.$videoSoundButton.classList.add('is--muted');
                }
            });
        }

        // seekbar handling
        if (this.$videoSeekbarDuration) {
            video.addEventListener('loadedmetadata', () => {
                const duration = video.duration;
                const minutes = Math.floor(duration / 60);
                const seconds = Math.round(duration % 60);
                this.$videoSeekbarDuration.textContent = `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
            });
        }

        if (this.$videoSeekbarCurrentTime) {
            video.addEventListener('timeupdate', () => {
                const currentTime = video.currentTime;
                const minutes = Math.floor(currentTime / 60);
                const seconds = Math.round(currentTime % 60);
                this.$videoSeekbarCurrentTime.textContent = `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
            });
        }

        if (this.$videoSeekbarBar) {
            video.addEventListener('timeupdate', () => {
                const percentage = (video.currentTime / video.duration) * 100;
                this.$videoSeekbarBar.style.width = percentage + '%';
            });

            this.$videoSeekbar.addEventListener('mouseover', () => {
                this.$videoSeekbarBar.classList.add('is--active');
            });

            this.$videoSeekbar.addEventListener('mouseout', () => {
                this.$videoSeekbarBar.classList.remove('is--active');
            });

            let sliderCanMove = false;

            this.$videoSeekbar.addEventListener('mousedown', () => {
                sliderCanMove = true;
            });

            window.addEventListener('mousemove', (e) => {
                if (sliderCanMove) {
                    const offset = this.$videoSeekbar.getBoundingClientRect().left;
                    const left = (e.clientX - offset);
                    const totalWidth = this.$videoSeekbar.clientWidth;
                    const percentage = (left / totalWidth);
                    video.currentTime = video.duration * percentage;
                }
            });

            window.addEventListener('mouseup', () => {
                sliderCanMove = false;
            });

            this.$videoSeekbar.addEventListener('click', (e) => {
                const offset = this.$videoSeekbar.getBoundingClientRect().left;
                const left = (e.clientX - offset);
                const totalWidth = this.$videoSeekbar.clientWidth;
                const percentage = (left / totalWidth);
                video.currentTime = video.duration * percentage;
            });
        }
    }
}

export { VideoControls };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $$roots = $context.querySelectorAll('[data-video-controls="root"]');
        $$roots.forEach(($root, index) => {
            const $rootAPI = new VideoControls($root, index);
            $rootAPI.initialize();
        });
    }
});
